import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import isArray from 'lodash/isArray';
import classnames from 'classnames';
import Loader from '../loader/Loader';

var GridBody =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridBody, _React$Component);

  function GridBody(props) {
    var _this;

    _classCallCheck(this, GridBody);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridBody).call(this, props));

    _this.renderBodyCell = function (row, column) {
      var text = get(row, column.field, '');

      if (column.formatter) {
        return column.formatter(row);
      } else if (typeof text === 'string' || typeof text === 'number') {
        return text;
      }

      return '';
    };

    _this.renderBodyAction = function (row, rowIndex) {
      var _this$props = _this.props,
          classes = _this$props.classes,
          actions = _this$props.actions,
          getStyleActionCellWidth = _this$props.getStyleActionCellWidth,
          slim = _this$props.slim;

      if (!actions.length) {
        return null;
      }

      return React.createElement(React.Fragment, null, React.createElement("td", {
        className: classnames(classes.td, _defineProperty({}, classes.tdSlim, slim)),
        style: getStyleActionCellWidth()
      }, actions.map(function (action, actionIndex) {
        return React.createElement(Tooltip, {
          key: "cell-action-".concat(rowIndex, "-").concat(actionIndex),
          title: action.label
        }, React.createElement(IconButton, {
          "aria-label": action.label,
          onClick: function onClick() {
            return action.func(row);
          },
          size: 'small'
        }, action.icon));
      })));
    };

    _this.onDropDown = function (row) {
      var onDropDown = _this.props.onDropDown;
      var isOpened = isEqual(_this.state.openedRow, row);
      var newState = {
        openedRow: isOpened ? undefined : row
      };

      if (isOpened) {
        newState.selectedDropDownRow = undefined;
      }

      _this.setState(newState, function () {
        onDropDown(_this.state.openedRow);
      });
    };
    /**
     * Проверка активной строки
     * @param row
     */


    _this.isSelected = function (row) {
      return isEqual(_this.props.selected, row);
    };

    _this.onContextMenu = function (row) {
      return function (event) {
        var openContextMenu = _this.props.openContextMenu;

        _this.onSelect(row);

        if (openContextMenu) {
          openContextMenu(event);
        }
      };
    };

    _this.state = {
      openedRow: undefined,
      selectedDropDownRow: undefined
    };
    return _this;
  }

  _createClass(GridBody, [{
    key: "onSelectDropDownRow",
    value: function onSelectDropDownRow(row) {
      this.setState({
        selectedDropDownRow: isEqual(this.state.selectedDropDownRow, row) ? undefined : row
      });
    }
  }, {
    key: "onDoubleClickDropDownRow",
    value: function onDoubleClickDropDownRow(row) {
      var onDoubleClickDropDownRow = this.props.onDoubleClickDropDownRow;

      if (onDoubleClickDropDownRow) {
        onDoubleClickDropDownRow(row);
      }
    }
  }, {
    key: "onSelect",
    value: function onSelect(row) {
      var onSelect = this.props.onSelect;

      if (onSelect) {
        onSelect(row);
      }
    }
  }, {
    key: "onDoubleClick",
    value: function onDoubleClick(row) {
      var onDoubleClick = this.props.onDoubleClick;

      if (onDoubleClick) {
        onDoubleClick(row);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          data = _this$props2.data,
          columns = _this$props2.columns,
          classes = _this$props2.classes,
          getStyleCellWidth = _this$props2.getStyleCellWidth,
          dropDownData = _this$props2.dropDownData,
          isDropDown = _this$props2.isDropDown,
          dropDownDataLoading = _this$props2.dropDownDataLoading,
          trStyleGenerator = _this$props2.trStyleGenerator,
          slim = _this$props2.slim;
      var _this$state = this.state,
          openedRow = _this$state.openedRow,
          selectedDropDownRow = _this$state.selectedDropDownRow;
      return React.createElement("tbody", {
        className: classes.tbody
      }, data && data.map(function (row, rowIndex) {
        var _classnames2;

        var isSelected = _this2.isSelected(row);

        var isOpened = isEqual(openedRow, row);
        var trStyle = trStyleGenerator ? trStyleGenerator(row) : null;
        var tr = React.createElement(React.Fragment, {
          key: "row-body-".concat(rowIndex)
        }, React.createElement("tr", {
          onClick: function onClick() {
            return _this2.onSelect(row);
          },
          onDoubleClick: function onDoubleClick() {
            return _this2.onDoubleClick(row);
          },
          className: classnames(classes.tr, (_classnames2 = {}, _defineProperty(_classnames2, classes.selected, isSelected), _defineProperty(_classnames2, classes.trSlim, slim), _classnames2)),
          style: trStyle
        }, isDropDown && React.createElement("td", {
          className: classnames(classes.td, classes.dropDownTd, _defineProperty({}, classes.tdSlim, slim))
        }, React.createElement(IconButton, {
          size: 'small',
          onClick: function onClick() {
            return _this2.onDropDown(row);
          }
        }, isOpened ? React.createElement(ArrowDropUp, {
          fontSize: 'small',
          color: 'inherit'
        }) : React.createElement(ArrowDropDown, {
          fontSize: 'small',
          color: 'inherit'
        }))), columns.map(function (column) {
          if (column.hide) {
            return null;
          }

          return React.createElement("td", {
            className: classnames(classes.td, _defineProperty({}, classes.tdSlim, slim)),
            style: getStyleCellWidth(column),
            key: "body-cell-".concat(rowIndex, "-").concat(column.field),
            onContextMenu: _this2.onContextMenu(row)
          }, _this2.renderBodyCell(row, column));
        }), _this2.renderBodyAction(row, rowIndex)), isOpened && dropDownDataLoading && React.createElement("tr", {
          key: "row-body-".concat(rowIndex, "-dropDownDataLoading")
        }, React.createElement("td", {
          className: classnames(classes.td, _defineProperty({}, classes.tdSlim, slim)),
          colSpan: columns.length + 1
        }, React.createElement("div", {
          className: classes.loadingTdContainer
        }, React.createElement("div", {
          className: classes.loading
        }, React.createElement(Loader, null))))), isOpened && !dropDownDataLoading && isArray(dropDownData) && dropDownData.map(function (dropDownRow, dropDownRowIndex) {
          var isSelectedDropDownRow = isEqual(selectedDropDownRow, dropDownRow);
          return React.createElement("tr", {
            key: "row-body-".concat(rowIndex, "-").concat(dropDownRowIndex),
            onClick: function onClick() {
              return _this2.onSelectDropDownRow(dropDownRow);
            },
            onDoubleClick: function onDoubleClick() {
              return _this2.onDoubleClickDropDownRow(dropDownRow);
            },
            className: "".concat(classes.dropDownTr, " ").concat(isSelectedDropDownRow ? classes.dropDownSelected : '')
          }, React.createElement("td", {
            className: classnames(classes.td, classes.dropDownTd)
          }, "\xA0"), columns.map(function (column) {
            if (column.hide) {
              return null;
            }

            return React.createElement("td", {
              className: classnames(classes.td, _defineProperty({}, classes.tdSlim, slim)),
              style: getStyleCellWidth(column),
              key: "body-cell-".concat(rowIndex, "-").concat(dropDownRowIndex, "-").concat(column.field)
            }, _this2.renderBodyCell(dropDownRow, column));
          }), _this2.renderBodyAction(dropDownRow, rowIndex));
        }));
        return tr;
      }), (data && data.length === 0 || !data) && React.createElement("tr", {
        key: "row-body-1",
        className: classes.trEmpty
      }, columns.map(function (column) {
        if (column.hide) {
          return null;
        }

        return React.createElement("td", {
          // className={classes.td}
          style: getStyleCellWidth(column),
          key: "body-cell-".concat(column.field)
        }, "\xA0");
      }), React.createElement("td", null, "\xA0")));
    }
  }]);

  return GridBody;
}(React.Component);

export default GridBody;